package one.healthium.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class ShoppingListDataQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> selectShoppingListData(listId: String, mapper: (
    id: String,
    listId: String,
    itemId: String,
    checked: Long,
  ) -> T): Query<T> = SelectShoppingListDataQuery(listId) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!
    )
  }

  public fun selectShoppingListData(listId: String): Query<ShoppingListDataEntity> = selectShoppingListData(listId, ::ShoppingListDataEntity)

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertData(shoppingListDataEntity: ShoppingListDataEntity): Long {
    val result = driver.execute(2_089_074_284, """INSERT OR REPLACE INTO shoppingListDataEntity (id, listId, itemId, checked) VALUES (?, ?, ?, ?)""", 4) {
          var parameterIndex = 0
          bindString(parameterIndex++, shoppingListDataEntity.id)
          bindString(parameterIndex++, shoppingListDataEntity.listId)
          bindString(parameterIndex++, shoppingListDataEntity.itemId)
          bindLong(parameterIndex++, shoppingListDataEntity.checked)
        }.await()
    notifyQueries(2_089_074_284) { emit ->
      emit("shoppingListDataEntity")
    }
    return result
  }

  private inner class SelectShoppingListDataQuery<out T : Any>(
    public val listId: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("shoppingListDataEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("shoppingListDataEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(1_241_991_925, """
    |SELECT shoppingListDataEntity.id, shoppingListDataEntity.listId, shoppingListDataEntity.itemId, shoppingListDataEntity.checked FROM shoppingListDataEntity
    |WHERE listId = ?
    """.trimMargin(), mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, listId)
    }

    override fun toString(): String = "ShoppingListData.sq:selectShoppingListData"
  }
}
